import { render, staticRenderFns } from "./regSearchFilter.vue?vue&type=template&id=71407610"
import script from "./regSearchFilter.vue?vue&type=script&lang=js"
export * from "./regSearchFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports